const customer2_name_reducer = (state = "", action) => {
	switch(action.type) {

		case 'UPDATECUST2NAME':
			return typeof action.payload !== "undefined" ? action.payload : "";

		default:
			return state;
	}
}

export default customer2_name_reducer;